<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-modal
        title="Choose period"
        class="modal-primary"
        v-model="modalDate"
        @ok="fetchData(), modalDate = false"
      >
        <b-form>
          <b-form-group label="From" label-for="date" :label-cols="3">
            <datepicker use-utc
              format="yyyy-MM-dd"
              :bootstrap-styling="true"
              v-model="dateFrom"
              name="dateFrom"
            ></datepicker>
          </b-form-group>
          <b-form-group label="To" label-for="dateTo" :label-cols="3">
            <datepicker use-utc
              format="yyyy-MM-dd"
              :bootstrap-styling="true"
              v-model="dateTo"
              name="dateTo"
            ></datepicker>
          </b-form-group>
        </b-form>
      </b-modal>

      <b-card class="backClass" header="Received">
        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">
            Received - {{ title }}
            <small style="font-weight:600; color:#20a8d8">
              {{ from ? from : dateFrom }}
              <b>|</b>
              {{ to ? to : dateTo }}
            </small>
            <!-- <b-button
              @click="detailView"
              class="btn-outline btn-sm ml-3"
              variant="outline-primary"
              right
            >
              Product Groups
            </b-button> -->
          </h5>
          <div class="card-header-actions">
            <b-button
              v-if="chartType !== 'company'"
              class="download-button"
              variant="transparent p-1"
              @click="downloadExcel()"> 
              <i class="fa fa-file-excel-o" title="Download Excel" aria-hidden="true" style="color: rgb(32, 168, 216);"></i>
          </b-button>
            <b-button
              @click="modalDateEvent"
              class
              style="height: 26px; width: 26px"
              variant="transparent p-0"
            >
              <i class="icon-calendar" style="color: #20a8d8;"></i>
            </b-button>
            <b-button
              @click="toggleFullScreen"
              style="height: 26px; width: 26px"
              class="float-right"
              variant="transparent p-0"
              right
            >
              <i style="color: #20a8d8;" class="icon-frame"></i>
            </b-button>
          </div>
        </div>
        <!-- <div style="width: 100%; display: flex; justify-content: flex-end;">
         <h5>Quantity</h5>
         <c-switch
           class="mx-1"
           color="primary"
           v-model="valueQuantity"
           value="true"
           uncheckedValue="false"
           variant="pill"
         />
         <h5>Financials</h5>
       </div> -->
        <!-- <div style="width: 100%; display: flex; justify-content: flex-start; margin-bottom:5px; ">
          <span style="line-height:30px; margin-right:22px">Select Models:  </span>
             <b-form-select
              v-model="selected"
              :options="options"
              style="width:140px"
              value-field="item"
              @change="this.fetchData"
              text-field="name"
            ></b-form-select>
        </div> -->
        <div class="chart-wrapper">
          <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <div v-if="locParam" slot="footer">
          <b-button
            :disabled="!showAll"
            class="btn-outline"
            variant="outline-primary"
            left
            @click="showAll = false, fetchData()"
          >Top 10</b-button>
          <b-button
            :disabled="showAll"
            class="btn-outline float-right"
            variant="outline-primary"
            right
            @click="showAll = true, fetchData()"
          >All Data</b-button>
          <b-button
            class="btn-outline text"
            v-if="isCelia"
            style="margin-right:10px; float:right"
            variant="outline-primary"
            @click=" () => $router.push('/base/TableAllData?type=Received&date_from=' +  (from ? from : dateFrom) + '&date_to=' +  (to ? to : dateTo))"
          >Overall Data</b-button>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
  import { Chart } from "highcharts-vue";
  import router from "../../router";
  import Datepicker from "vuejs-datepicker";
  import { Switch as cSwitch } from "@coreui/vue";

  export default {
    name: "Received",
    components: {
      router,
      highcharts: Chart,
      Datepicker,
      cSwitch
    },
    props: ["lgSize", "lgOffset", "locParam", "idCity", "title"],
    data: function() {
      return {
        fullscreen: false,
        loadingData: false,
        showAll: false,
        modalDate: false,
        valueQuantity: false,
        isCelia: false,
        selected: 'All',
        options: [
          { item: 'All', name: 'All' },
          { item: 'XM2', name: 'XM2' },
          { item: 'XM3', name: 'XM3' },
        ],
        dateName: "",
        dateFrom: "",
        company: "",
        dateTo: "",
        locationName: "",
        productGroup: "",
        locationsIds: "",
        chartOptions: {
          chart: {
            type: "column",
            backgroundColor: "transparent",
            events: {}
          },
          exporting: {
            enabled: true
          },
          title: {
            text: "",
            style: {
              color: "white",
              display: ""
            }
          },
          subtitle: {
            text: "",
            style: {
              color: "white",
              display: "none"
            }
          },
          xAxis: {
            type: "category",
            labels: {
              style: {
                color: "white"
              }
            }
          },
          yAxis: {
            title: {
              text: "Percentage Of Total"
            }
          },
          legend: {
            enabled: false
          },
          tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat:
                "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: false,
                format: "{point.name}: {point.y:.1f}%",
                color: "white",
                style: {
                  textOutline: false
                }
              },
              point: {
                events: {
                  click: ({ point }) => {
                    console.log(point);
                    let name = point.name.split("(");
                    console.log(name);
                    // if (point.name) {
                    //   this.productGroup = point.name;
                    //   router.push(
                    //     "/base/Tables/?location=" +
                    //       point.series.name +
                    //       "%2834%29" +
                    //       "&productGroup=" +
                    //       this.productGroup +
                    //       "&type=Shipped&date_from=" +
                    //       this.dateFrom +
                    //       "&date_to=" +
                    //       this.dateTo +
                    //       "&clients=" +
                    //       this.locationsIds
                    //   );
                    // }
                  }
                }
              }
            }
          },
          drilldown: {
            activeAxisLabelStyle: {
              textDecoration: "none",
              color: "white"
            },
            activeDataLabelStyle: {
              color: "white"
            }
          },
          series: [
            {
              name: "Locations",
              colorByPoint: true,
              data: null
            }
          ]
        }
      };
    },
    watch: {
      valueQuantity(value) {
        this.fetchData();
        if (this.fullScreen) {
          this.$refs.backRef.chart.options.chart.height = "50%";
        } else {
          this.$refs.backRef.chart.options.chart.height = 400;
        }
      }
    },
    methods: {
      detailView() {
        this.$emit('detailViewShip');
      },
      toggleFullScreen() {
        this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
          wrap: false,
          callback: this.fullscreenChange
        });
      },
      fullscreenChange(fullscreen) {
        this.fullscreen = fullscreen;
        if (this.fullscreen) {
          this.$refs.backRef.chart.options.chart.height = "50%";
        } else {
          this.$refs.backRef.chart.options.chart.height = 400;
        }
        this.$refs.backRef.chart.reflow();
      },
      downloadExcel() {
      this.loading2019 = true;
      let params = {};
      params = {
          date_from: this.dateFrom,
          date_to: this.dateTo,
          company: this.company,
          chartType: "Received",
          xml: "true"
      };

      this.$http
        .get("api/tec/tables/recieved.php", {
          params,
          responseType: "blob"
        })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TableReport.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          err => {
            this.loading2019 = false;
            console.log(err);
          }
        );
      },
      fetchData() {
        this.loadingData = true;
        let params = {};
        let finType = "Fin";
        if (!this.valueQuantity || this.valueQuantity == "false") {
          finType = "Qty";
        }
        params = {
          date_from: this.dateFrom,
          date_to: this.dateTo,
          company: this.company,
          chartType: "Received"
        };
        this.$http
            .get("api/tec/charts/chart_data.php", { params })
            .then(
                res => {
                  //this.locationName = res.data.dnData[0].name;
                  if (!this.showAll) {
                    let tmp = res.data.upData;
                    tmp.sort((a, b) =>
                        parseFloat(a.locationTotal) > parseFloat(b.locationTotal)
                            ? -1
                            : 1
                    );

                    // let smp = res.data.dnData;

                    // smp.forEach((value, index) => {
                    //   value.data.sort((a, b) =>
                    //     parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
                    //   );
                    // });

                    let newArr = tmp.slice(0, 10);
                    if (this.locParam == 0) {
                      if (smp.length != 0) {
                        this.chartOptions.series[0].data = smp[0].data;
                      }
                    } else {
                      this.chartOptions.series[0].data = newArr;
                      // this.chartOptions.drilldown.series = smp;
                    }
                  } else {
                    let smp = res.data.dnData;

                    // smp.forEach((value, index) => {
                    //   value.data.sort((a, b) =>
                    //     parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
                    //   );
                    // });
                    let tmp = res.data.upData;
                    tmp.sort((a, b) =>
                        parseFloat(a.locationTotal) > parseFloat(b.locationTotal)
                            ? -1
                            : 1
                    );
                    this.chartOptions.series[0].data = tmp;
                    //this.chartOptions.drilldown.series = smp;

                  }

                  //  // Getting total amount wihtout response
                  // var seriesData = this.chartOptions.series;
                  // var pointSum = 0;
                  // seriesData.forEach(function(point) {
                  //   var datasValue = point.data;
                  //   datasValue.forEach(function(value) {
                  //     pointSum += parseInt(value.locationTotal);
                  //   })
                  // });

                  if (finType == "Fin") {
                    this.chartOptions.title.text = "Total : $" + res.data.totals.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
                  } else {
                    this.chartOptions.title.text = "Total units: " +  res.data.totals;
                  }


                  this.loadingData = false;
                  setTimeout(() => {
                    this.changeHeight();
                  });
                },
                err => {
                  this.loadingData = false;
                  console.log(err);
                }
            );
      },
      changeHeight() {
        if (this.fullscreen) {
          this.$refs.backRef.chart.options.chart.height = "50%";
        } else {
          this.$refs.backRef.chart.options.chart.height = 400;
        }
        this.$refs.backRef.chart.reflow();
      },
      modalDateEvent() {
        if (this.fullScreen) {
          this.toggleFullScreen();
          this.modalDate = true;
        } else {
          this.modalDate = true;
        }
      },
      downloadPDF() {
        if (this.locParam == 1) {
          this.$refs.backRef.chart.options.title.text =
              "Received equipment | " +
              (this.from ? this.from : this.dateFrom) +
              " - " +
              (this.to ? this.to : this.dateTo) +
              " " +
              this.locationName;
          this.$refs.backRef.chart.options.title.style.color = "black";
        } else {
          this.$refs.backRef.chart.options.title.text =
              "Received equipment | " + this.from
                  ? this.from
                  : this.dateFrom + " - " + this.to
                  ? this.to
                  : this.dateTo + " " + this.nameCity;
          this.$refs.backRef.chart.options.title.style.color = "black";
        }

        this.$refs.backRef.chart.options.title.style.display = "block";
        this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
            "black";

        this.$refs.backRef.chart.options.xAxis.forEach(obj => {
          obj.labels.style.color = "black";
        });

        this.$refs.backRef.chart.exportChart({
          type: "application/pdf",
          filename:
              "ReceivedEquipment-" +
              (this.from ? this.from : this.dateFrom) +
              "-" +
              (this.to ? this.to : this.dateTo)
        });

        this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
            "white";
      }
    },
    computed: {
      from() {
        if (typeof this.dateFrom === "object") {
          this.dateFrom = this.dateFrom.toISOString().split("T")[0];
          return this.dateFrom;
        }
      },
      to() {
        if (typeof this.dateTo === "object") {
          this.dateTo = this.dateTo.toISOString().split("T")[0];
          return this.dateTo;
        }
      }
    },
    mounted() {
      this.company = this.title;
      if (!localStorage.getItem("tec_user")) {
        router.push("/pages/login/");
      }
      if (localStorage.getItem("alpha_full_name") === "Celia Mijares") {
        this.isCelia = true
      }
      if (this.locParam == 1) {
        this.locationsIds = localStorage.getItem("locations");
      } else {
        this.locationsIds = this.idCity;
        console.log("THIS IS IT :" + this.idCity);
      }
      this.valueQuantity = false;
      
      let fromDate = new Date();
      fromDate.setDate(fromDate.getDate() - 30);

      let currentDateWithFormat = new Date()
          .toJSON()
          .slice(0, 10)
          .replace(/-/g, "/");

      this.dateFrom = fromDate;
      this.dateTo = currentDateWithFormat;

      this.fetchData();
    }
  };
</script>

<style>
  /* IE fix */
  #card-chart-01,
  #card-chart-02 {
    width: 100% !important;
  }
  .small {
    float: right !important;
  }
</style>
